<div class="mess-excel">
    <div class="mess-excel__header">
        <div class="mess-excel__title" (click)="backToMessDoDetails()">
            <i class="fa fa-arrow-left mess-excel__back-icon" aria-hidden="true"></i>
            <span class="mess-excel__title-text">
                <span>Mess Daysheet Closed</span>
                <span class="mess-excel__building-name" *ngIf="messBuildingName">{{ messBuildingName }}</span>
            </span>
        </div>
        <div class="mess-excel__header-actions">
            <button type="button" class="mess-excel__btn" (click)="onDownloadExcelClick()">Download Excel</button>
            <button type="button" class="mess-excel__btn mess-excel__btn--fusion"
                (click)="onDownloadFusionExcelClick()">Fusion Excel Download</button>
            <button type="button" class="mess-excel__btn mess-excel__btn--strength"
                (click)="onDownloadSupplyStrengthExcelClick()">Supply Strength Excel</button>
        </div>
    </div>

    <div class="mess-excel__summary" *ngIf="inventroyData">
        <div class="mess-excel__pill">
            <div class="mess-excel__pill-label">Daysheet Date</div>
            <div class="mess-excel__pill-value">{{ daysheetDate }}</div>
        </div>
        <div class="mess-excel__pill">
            <div class="mess-excel__pill-label">Status</div>
            <div class="mess-excel__pill-value">{{ inventroyData?.status }}</div>
        </div>
        <div class="mess-excel__pill">
            <div class="mess-excel__pill-label">Students Count</div>
            <div class="mess-excel__pill-value">{{ inventroyData?.studentCount ?? 0 }}</div>
        </div>
        <div class="mess-excel__pill">
            <div class="mess-excel__pill-label">Employees Count</div>
            <div class="mess-excel__pill-value">{{ inventroyData?.employeeCount ?? 0 }}</div>
        </div>
        <div class="mess-excel__pill">
            <div class="mess-excel__pill-label">SubStaff Count</div>
            <div class="mess-excel__pill-value">{{ inventroyData?.subStaffCount ?? 0 }}</div>
        </div>
        <div class="mess-excel__pill">
            <div class="mess-excel__pill-label">Others Count</div>
            <div class="mess-excel__pill-value">{{ inventroyData?.visitorsCount ?? 0 }}</div>
        </div>
        <div class="mess-excel__view-toggle" *ngIf="scenarioBasedMenuItemsList?.length">
            <button type="button" class="mess-excel__view-toggle-btn"
                [class.mess-excel__view-toggle-btn--active]="summaryViewMode === 'all'"
                (click)="setSummaryViewMode('all')">All</button>
            <button type="button" class="mess-excel__view-toggle-btn"
                [class.mess-excel__view-toggle-btn--active]="summaryViewMode === 'summary'"
                (click)="setSummaryViewMode('summary')">Summary</button>
        </div>
    </div>

    <!-- All: Today's Menu + merged inventory table -->
    <div class="mess-excel__all-view" *ngIf="scenarioBasedMenuItemsList?.length && summaryViewMode === 'all'">
        <div class="mess-excel__todays-menu">
            <div class="mess-excel__todays-menu-title">Today's Menu</div>
            <div class="mess-excel__todays-menu-row" *ngFor="let menu of getTodaysMenuList()">
                <span class="mess-excel__todays-menu-scenario">{{ menu.scenarioName }}:</span>
                <span class="mess-excel__todays-menu-items">{{ menu.menuItems }} .</span>
            </div>
        </div>

        <div class="mess-excel__scenario-box">
            <div class="mess-excel__table-wrap">
                <table class="mess-excel__table">
                    <thead>
                        <tr>
                            <th>Item</th>
                            <th class="num">Rate</th>
                            <th class="num">Breakfast</th>
                            <th class="num">Lunch</th>
                            <th class="num">Snacks</th>
                            <th class="num">Dinner</th>
                            <th class="num">Total Qty</th>
                            <th class="num">Open Qty</th>
                            <th class="num">Total Cost</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of allSummaryRows">
                            <td class="mess-excel__item-name">{{ item.itemNameEn }}</td>
                            <td class="num">{{ inrGroupedNumber(item.ratePerUnit) }}</td>
                            <td class="num">{{ item.bfQty }}</td>
                            <td class="num">{{ item.lunchQty }}</td>
                            <td class="num">{{ item.snacksQty }}</td>
                            <td class="num">{{ item.dinnerQty }}</td>
                            <td class="num">{{ item.totalQty }}</td>
                            <td class="num">{{ inrGroupedNumber(item.onHandQty) }}</td>
                            <td class="num">{{ inrGroupedNumber(item.totalCost) }}</td>
                        </tr>
                        <tr *ngIf="!allSummaryRows.length">
                            <td class="mess-excel__empty-cell" colspan="9">No inventory items</td>
                        </tr>
                    </tbody>
                    <tfoot *ngIf="allSummaryRows.length">
                        <tr>
                            <td colspan="8" class="mess-excel__total-label">Total Cost</td>
                            <td class="num mess-excel__total-value">₹{{ inrGroupedNumber(allSummaryTotalCost) }}</td>
                        </tr>
                    </tfoot>
                </table>
            </div>
        </div>
    </div>

    <!-- Summary: per-scenario boxes; only that meal's Qty column -->
    <div class="mess-excel__scenarios" *ngIf="scenarioBasedMenuItemsList?.length && summaryViewMode === 'summary'">
        <div class="mess-excel__scenario-box" *ngFor="let scenario of scenarioBasedMenuItemsList">
            <button type="button" class="mess-excel__scenario-title"
                (click)="toggleScenarioExpand(scenario)"
                [attr.aria-expanded]="isScenarioExpanded(scenario)">
                <span class="mess-excel__scenario-title-text">
                    <span>{{ scenario.scenarioName }}</span>
                    <span class="mess-excel__scenario-menu-count">({{ getScenarioMenuItemCount(scenario) }})</span>
                </span>
                <i class="fa" [class.fa-chevron-up]="isScenarioExpanded(scenario)"
                    [class.fa-chevron-down]="!isScenarioExpanded(scenario)" aria-hidden="true"></i>
            </button>
            <div class="mess-excel__scenario-menu">
                <span class="mess-excel__scenario-menu-label">Menu Items:</span>
                {{ getScenarioMenuLabel(scenario) }}
            </div>
            <div class="mess-excel__table-wrap" *ngIf="isScenarioExpanded(scenario)">
                <table class="mess-excel__table mess-excel__table--scenario">
                    <thead>
                        <tr>
                            <th>Item</th>
                            <th class="num">Rate</th>
                            <th class="num">{{ getScenarioMealQtyLabel(scenario) }}</th>
                            <th class="num">Total Qty</th>
                            <th class="num">Open Qty</th>
                            <th class="num">Total Cost</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of scenario.saveInventoryBalanceDetails">
                            <td class="mess-excel__item-name">{{ item.itemNameEn }}</td>
                            <td class="num">{{ inrGroupedNumber(item.ratePerUnit) }}</td>
                            <td class="num">{{ getScenarioMealQtyValue(scenario, item) }}</td>
                            <td class="num">{{ item.totalQty }}</td>
                            <td class="num">{{ inrGroupedNumber(item.onHandQty) }}</td>
                            <td class="num">{{ inrGroupedNumber(item.totalCost) }}</td>
                        </tr>
                        <tr *ngIf="!scenario.saveInventoryBalanceDetails?.length">
                            <td class="mess-excel__empty-cell" colspan="6">No inventory items</td>
                        </tr>
                    </tbody>
                    <tfoot *ngIf="scenario.saveInventoryBalanceDetails?.length">
                        <tr>
                            <td colspan="5" class="mess-excel__total-label">Total Cost</td>
                            <td class="num mess-excel__total-value">₹{{ inrGroupedNumber(getScenarioTotalCost(scenario)) }}</td>
                        </tr>
                    </tfoot>
                </table>
            </div>
        </div>
    </div>

    <div class="mess-excel__section" *ngIf="!scenarioBasedMenuItemsList?.length">
        <div class="mess-excel__section-title">Inventory BalanceDetails</div>
        <ag-grid-angular class="ag-theme-alpine mess-excel__grid" style="width: 100%; height: 360px;"
            [rowData]="inventoryRowData" [columnDefs]="inventoryColDefs" [defaultColDef]="defaultColDef"
            (gridReady)="onInventoryGridReady($event)">
        </ag-grid-angular>
    </div>

    <div class="mess-excel__section">
        <div class="mess-excel__section-title">Supply Buildings</div>
        <ag-grid-angular class="ag-theme-alpine mess-excel__grid" style="width: 100%; height: 260px; margin-bottom: 50px;"
            [rowData]="supplyRowData" [columnDefs]="supplyColDefs" [defaultColDef]="supplyDefaultColDef"
            (gridReady)="onSupplyGridReady($event)">
        </ag-grid-angular>
    </div>
</div>

<!-- ================================ loader ======================-->
<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
    <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>
